/* eslint-disable @typescript-eslint/no-explicit-any */
import whenDomReady from 'when-dom-ready';
function initialise() {
    const subnav = document.querySelector('.js-subnav');
    const triggers = document.querySelectorAll('.js-subnav .js-has-dropdown');
    const subnavWrapper = document.querySelector('.js-subnav-wrapper');
    const subnavBreadcrumbs = document.querySelector('.js-subnav__left');
    const subnavLinks = document.querySelector('.js-subnav__links');
    const subnavLinksOther = document.querySelector('.js-subnav__links-other');
    const subnavListItems = document.querySelectorAll('.js-subnav__links li');
    const subnavListLastItem = subnavListItems[subnavListItems.length - 1];
    const subnavDropdownContent = document.querySelector('.js-dropdown-subnav .subnav__dropdown-content');
    let subNavItems = [];
    initSubnav();
    // Setup a resize observer to track changes.
    window.addEventListener('resize', initSubnav);
    // Subnav update.
    function initSubnav() {
        subnavListItems.forEach((navItem) => {
            navItem.classList.remove('is-other');
        });
        if (window.matchMedia('(min-width: 1024px)').matches) {
            if (!subnavWrapper ||
                !subnav ||
                !subnavBreadcrumbs ||
                !subnavLinks ||
                !subnavLinksOther ||
                !subnavListLastItem) {
                return;
            }
            let itemsWidthSum = getSubNavItemsWidthSum();
            const spaceForItems = getSubNavSpaceForItems();
            subnavLinksOther.classList.remove('is-shown');
            emptyElement(subnavDropdownContent);
            while (itemsWidthSum > spaceForItems) {
                if (!subnavLinksOther.classList.contains('is-shown')) {
                    subnavLinksOther.classList.add('is-shown');
                    itemsWidthSum += subnavLinksOther.offsetWidth;
                }
                itemsWidthSum -= hideSubNavItem();
            }
        }
        else {
            const breadcrumbsWidthSum = widthNoPadding(subnavBreadcrumbs);
            const spaceForItems = widthNoPadding(subnav);
            // Align breadcrumbs to right if necessary
            if (breadcrumbsWidthSum > spaceForItems) {
                subnav.scrollLeft += breadcrumbsWidthSum - spaceForItems;
            }
        }
    }
    // Get whole subnav width based on items widths
    function getSubNavItemsWidthSum() {
        let sum = 0;
        subNavItems = [];
        subnavListItems.forEach((navItem) => {
            navItem.classList.remove('is-other');
            subNavItems.push({
                el: navItem,
                width: outerWidthMargin(navItem),
                isOther: false,
            });
            sum += outerWidthMargin(navItem);
        });
        return sum;
    }
    // Space available for submenu items
    function getSubNavSpaceForItems() {
        return (widthNoPadding(subnav) - widthNoPadding(subnavBreadcrumbs) - widthNoPadding(subnavLinksOther));
    }
    // Hide item and eventually return its width
    function hideSubNavItem() {
        let index = subNavItems.length - 1;
        while (subNavItems[index].isOther && index > 0) {
            index--;
        }
        subNavItems[index].isOther = true;
        subNavItems[index].el.classList.add('is-other');
        // Clone links to others dropdown
        const clonedElem = subNavItems[index].el?.cloneNode(true);
        clonedElem.querySelector('a')?.classList.remove('subnav__link');
        clonedElem.querySelector('a')?.classList.add('subnav-link-secondary');
        if (clonedElem.querySelector('a')?.classList.contains('subnav__link--current')) {
            clonedElem.querySelector('a')?.classList.remove('subnav__link--current');
            clonedElem.querySelector('a')?.classList.add('subnav-link-secondary--current');
        }
        subnavDropdownContent.prepend(clonedElem);
        return index > 1 ? subNavItems[index].width : false;
    }
    // Calculate width with margins
    function outerWidthMargin(el) {
        let width = el.offsetWidth;
        const style = getComputedStyle(el);
        width += parseInt(style.marginLeft) + parseInt(style.marginRight);
        return width;
    }
    // Calculate width without paddings
    function widthNoPadding(el) {
        let width = el.offsetWidth;
        const style = getComputedStyle(el);
        width -= parseInt(style.paddingLeft) + parseInt(style.paddingRight);
        return width;
    }
    // Dropdown functionality
    // Hover over
    function handleEnter(event) {
        if (event.target instanceof Element) {
            event.target.classList.add('trigger-enter');
            setTimeout(() => {
                if (event.target instanceof Element) {
                    event.target.classList.contains('trigger-enter');
                }
            });
        }
    }
    // Hover out
    function handleLeave(event) {
        if (event.target instanceof Element) {
            event.target.classList.remove('trigger-enter');
        }
    }
    // Empty given element
    function emptyElement(el) {
        while (el.firstChild)
            el.removeChild(el.firstChild);
    }
    // Handle touch based devices
    for (let i = 0; i < triggers.length; i++) {
        // The "trigger" here is an <li /> we should be handling clicking on the anchor.
        const navItem = triggers[i];
        if ('touchstart' in window) {
            navItem.addEventListener('touchstart', handleEnter);
        }
        else {
            navItem.addEventListener('mouseenter', handleEnter);
        }
        if ('touchmove' in window) {
            navItem.addEventListener('touchmove', handleLeave);
        }
        else {
            navItem.addEventListener('mouseleave', handleLeave);
        }
        // Get anchor link.
        const navLink = navItem.firstElementChild;
        navLink.addEventListener('click', (e) => {
            const targetElement = e.target;
            const isDesktop = window.matchMedia('(min-width: 1190px)').matches;
            // Check if we've clicked on the icon, if so then don't navigate.
            if ((targetElement.matches('.js-subnav-link-dropdown') ||
                targetElement.matches('svg') ||
                targetElement.matches('use')) &&
                !isDesktop) {
                e.preventDefault();
                navLink.classList.toggle('is-open');
            }
        });
    }
}
whenDomReady().then(initialise);
